import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {Helper} from '../../helpers/helper.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {GeneralTermService} from '../../back-office/Services/general-term.service';
import {UserTerm} from '../../back-office/Models/UserTerm';
import {UntypedFormGroup} from '@angular/forms';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-accept-term',
  templateUrl: './accept-term.component.html',
  styleUrls: ['./accept-term.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AcceptTermComponent implements OnInit {
  public isLoaded = false;
  public token: string;
  public userTerm: UserTerm = new UserTerm();
  public classicBox;
  public enableSave = false;
  public baseUrl = environment.apiUrl;
  public form = new UntypedFormGroup({});
  public options: FormlyFormOptions = {};
  @ViewChild('classicForm', {static: false}) child;

  constructor(private generalTermService: GeneralTermService, public helper: Helper, private router: Router, private route: ActivatedRoute, private translate: TranslateService) {
  }


  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (Helper.isDefined(params['token'])) {
        this.token = params['token'];
        this.generalTermService.getTermByKey(this.token).subscribe(res => {
          this.userTerm = res;
          this.classicBox = <FormlyFieldConfig>[
            {
              fieldGroupClassName: 'row',
              key: 'accept_term',
              fieldGroup: [
                {
                  className: 'col-12',
                  type: 'checkbox',
                  key: 'agreeTerms',
                  templateOptions: {
                    label: this.translate.instant('admin.terms.accept.term.checkbox'),
                    required: false,
                  },
                  validation: {
                    messages: {
                      required: this.translate.instant('errors.required'),
                    },
                  },
                },
              ],
            },
            {
              fieldGroupClassName: 'row',
              key: 'accept_term',
              fieldGroup: [
                {
                  className: 'col-6 ',
                  type: 'input',
                  key: 'name',
                  templateOptions: {
                    label: this.translate.instant('doctrine.general_terms.name'),
                    required: true,
                    pattern: '[a-zA-Z0-9, _-]+',
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) =>
                        this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
                {
                  className: 'col-6 ',
                  type: 'input',
                  key: 'city',
                  templateOptions: {
                    label: this.translate.instant('doctrine.general_terms.city'),
                    required: true,
                    pattern: '[A-Za-z0-9 ]+',
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) =>
                        this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
              ],
            },
          ];
          this.isLoaded = true;
        });
      }
    });
    document.querySelector('body').setAttribute('themebg-pattern', 'theme1');
  }

  submitTerm() {
    this.generalTermService.acceptTerm(this.userTerm, this.token).subscribe(res => {
      this.helper.popMessageDialog(
        this.translate.instant('global.success_message.title'),
        this.translate.instant('admin.terms.accept.success.message'),
        'success',
        false
      );
      this.router.navigateByUrl('/login');
    });
  }

  enableButton(event) {
    if (this.child.data.accept_term.agreeTerms) {
      return this.enableSave = event;
    }
    return this.enableSave = false;
  }
}
